export const NANO_DROP_ORDER_PAGE = {
  title: 'Pedido',
  numberAbbreviation: 'nº',
  heldDay: 'Realizado dia',
  at: 'às',
  statusHistory: 'Histórico completo',
  statusHistoryButton: 'Ver histórico completo',
  productsSubtotal: 'Soma dos produtos',
  discount: 'Desconto',
  description: 'Descrição',
  shippingFee: 'Frete',
  total: 'Total',
  paymentMethod: 'Forma de pagamento',
  client: 'Cliente',
  corporateName: 'Razão Social',
  cnpj: 'CNPJ',
  addressWithComplement: 'Endereço com Complemento',
  zipCode: 'CEP',
  neighborhood: 'Bairro/Distrito',
  city: 'Município',
  state: 'UF',
  referencePoint: 'Ponto de referência',
  viewPhone: 'Ver telefone',
  unavailablePhone: 'Telefone indisponível',
  contactDialog: {
    whatsappButton: 'Falar via Whatsapp',
  },
  printOnAccept: 'Imprimir pedido ao aceitar',
  reject: 'Rejeitar',
  accept: 'Aceitar',
  cancel: 'Cancelar',
  print: 'Imprimir',
  leaveForDelivery: 'Sair para entrega',
  finalizeDelivery: 'Finalizar entrega',
  backToNanoDrop: 'Voltar para Nano Drop',
  loadError: 'Não foi possível carregar os detalhes do pedido.',
  notFound: 'Pedido não encontrado.',
  unavailableValue: '-',
  productThumbPlaceholderAlt: 'Imagem do produto',
  unitPriceSuffix: 'un',
  copyFieldAriaLabel: 'Copiar',
  copySuccess: 'Copiado para a área de transferência',
  nanoDropPrefix: 'Pedido Nano Drop',
  deliveryToday: 'hoje',
  deliveryTomorrow: 'amanhã',
  deliveryWindowCopy: 'das 8h às 18h',
  deliveredPrefix: 'Entregue',
  status: {
    waitingAcceptance: 'Aguardando o aceite',
    accepted: 'Aceito',
    courierOnTheWay: 'Entregador a caminho',
    delivered: 'Entregue',
    expired: 'Expirado',
    rejected: 'Rejeitado',
    cancelledByClient: 'Cancelado pelo cliente',
    cancelled: 'Cancelado',
    orderPlaced: 'Pedido colocado',
  },
} as const
